<template>
  <div class="activities">
    <template v-for="activity in data.activities" :key="activity.title">
      <ul>
        <li>{{ activity.title }}</li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  name: "TrainingRncpAccordionActivitiesComponent",
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  line-height: 2;
}
</style>
